import { render, staticRenderFns } from "./module-common-index.vue?vue&type=template&id=43579c31&scoped=true"
import script from "./module-common-index.vue?vue&type=script&lang=js"
export * from "./module-common-index.vue?vue&type=script&lang=js"
import style0 from "./module-common-index.vue?vue&type=style&index=0&id=43579c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43579c31",
  null
  
)

export default component.exports